import { useState } from 'react';
import { HOMEPAGE_IMAGE_LIMITS, type HomepageImage } from '@mcpanel/core';
import { api } from '../api/client';
import { errorMessage, useApp } from '../app-context';
import { Spinner } from '../components/feedback';

/** 背景・サーバーの写真。複数あれば公開ページで順に切り替わる */
export function HomepageImages({
  target,
  label,
  images,
  reload,
}: {
  target: string;
  label: string;
  images: HomepageImage[];
  reload: () => void;
}) {
  const { notify } = useApp();
  const [busy, setBusy] = useState(false);
  const mine = images.filter((image) => image.target === target);
  const run = async (action: () => Promise<unknown>, done: string) => {
    setBusy(true);
    try {
      await action();
      notify(done);
      reload();
    } catch (err) {
      notify(errorMessage(err), true);
    } finally {
      setBusy(false);
    }
  };
  const upload = (files: FileList | null) => {
    const list = Array.from(files ?? []);
    if (!list.length) return;
    void run(async () => {
      for (const file of list) await api.uploadHomepageImage(target, file);
    }, `${label}を追加しました`);
  };
  return (
    <div className="stack">
      <div className="row" style={{ flexWrap: 'wrap', gap: 8 }}>
        {mine.map((image) => (
          <figure key={image.id} style={{ margin: 0, width: 160 }}>
            <img
              src={`/site/media/${encodeURIComponent(image.id)}`}
              alt=""
              style={{ width: 160, height: 90, objectFit: 'cover', display: 'block' }}
            />
            <button
              type="button"
              className="btn danger"
              disabled={busy}
              onClick={() => {
                if (window.confirm(`この${label}を消しますか？`))
                  void run(() => api.deleteHomepageImage(image.id), `${label}を消しました`);
              }}
            >
              消す
            </button>
          </figure>
        ))}
        {!mine.length && <p className="small muted">まだありません。</p>}
      </div>
      <label className="field">
        {label}を追加（PNG・JPEG、1 枚 5 MB まで、{HOMEPAGE_IMAGE_LIMITS.perTarget} 枚まで）
        <input
          className="input"
          type="file"
          accept="image/png,image/jpeg"
          multiple
          disabled={busy || mine.length >= HOMEPAGE_IMAGE_LIMITS.perTarget}
          onChange={(e) => {
            upload(e.target.files);
            e.target.value = '';
          }}
        />
      </label>
      {busy && <Spinner />}
    </div>
  );
}
